import { List } from "components/common/List/List";
import { useSort } from "../../../ControlBar/Sort/useSort";
import { getSortListItems } from "components/modules/Editors/BulkResizer/BottomMenu/Content/Sort/Sort";
import { Translate } from "components/common/Translate/Translate";

export const Sort = () => {
    const { handleClick, sort: currentSort } = useSort();

    return (
        <div className="flex flex-col gap-3 text-xl">
            <div className="px-6 py-2 font-semibold border-b border-b-irGray-400 dark:border-b-none">
                <Translate keyName="mobile-sort-title" />
            </div>
            <List callback={handleClick} items={getSortListItems(currentSort)} />
        </div>
    );
};
